import { Box } from "@mui/material";
import { BarChart } from "@mui/x-charts/BarChart";

/* =====================
   TYPES
===================== */

type HeatmapRow = {
  capacity: string; // use string for band scale
  low: number;
  high: number;
};

/* =====================
   DATA
===================== */

// "100" first, then the rest for spacing
const dataset: HeatmapRow[] = [
  { capacity: "100", low: 3, high: 3 }, // stacked bar at 100
  { capacity: "200", low: 0, high: 0 },
  { capacity: "400", low: 0, high: 0 },
  { capacity: "800", low: 0, high: 0 },
  { capacity: "1000", low: 0, high: 0 },
];

/* =====================
   COMPONENT
===================== */

const CapacitySpeedHeatmap = () => {
  return (
    <Box
      sx={{
        backgroundColor: "#08065cff", // light blue chart background
        padding: 2,
        borderRadius: 2,
      }}
    >
      <BarChart
        dataset={dataset}
        xAxis={[
          {
            dataKey: "capacity",
            scaleType: "band", // required for stacked bars
            label: "Capacity",
          },
        ]}
        yAxis={[
          {
            label: "Internet Upload Speed",
            min: 0,
            max: 10,
          },
        ]}
        series={[
          {
            dataKey: "low",
            label: "0–5 Mbps",
            stack: "speed",
            color: "#ffeb3b", // yellow
          },
          {
            dataKey: "high",
            label: "5–10 Mbps",
            stack: "speed",
            color: "#8321f338", // blue
          },
        ]}
        height={300}
      />
    </Box>
  );
};

export default CapacitySpeedHeatmap;
